export const getArticleCategory = (article) =>
  article?.article_category
    ? article?.article_category?.name
    : article?.reference?.reference_category?.name;
